import { useMutation } from "@tanstack/react-query";

import { requestResetPassword, RequestResetPasswordRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useRequestResetPassword = () => {
  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: RequestResetPasswordRequest) => {
      return requestResetPassword(body);
    },
    onSuccess: () => {
      openToast({ variant: "info", message: "New code has been sent!" });
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useRequestResetPassword };
